// React
import React, { useState } from 'react';

// Redux
import { connect } from 'react-redux';
import { withRoomContext } from '../../../RoomContext';
import * as settingsActions from '../../../actions/settingsActions';

// Prop types
import PropTypes from 'prop-types';

// Message
import { FormattedMessage } from 'react-intl';

// Mui styles
import { withStyles, MuiThemeProvider, createTheme } from '@material-ui/core/styles';

// Mui core
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

// Icon
import FlipCameraAndroidIcon from '@material-ui/icons/FlipCameraAndroid';

const styles = (theme) =>
	({
		root : {
			zIndex : 99,
			width  : '100%',
			height : '100%'
		},
		dialogPaper : {
			padding                        : '1% 2%',
			width                          : '20vw',
			[theme.breakpoints.down('lg')] : {
				width : '25vw'
			},
			[theme.breakpoints.down('md')] : {
				width : '50vw'
			},
			[theme.breakpoints.down('sm')] : {
				width : '70vw'
			},
			[theme.breakpoints.down('xs')] : {
				width : '90vw'
			}
		},
		titleIcon : {
			width        : '3rem',
			height       : '3rem',
			marginBottom : '10%'
		},
		titleText : {
			color      : '#999898',
			fontSize   : '1rem',
			fontWeight : 'bold'
		},
		infoGroup : {
			width         : '100%',
			display       : 'flex',
			paddingBottom : '1rem',
			alignItems    : 'center',
			position      : 'relative'
		},
		contentText : {
			width    : '30%',
			color    : '#999898',
			fontSize : '0.7rem'
		},
		input : {
			width        : '70%',
			background   : '#999898',
			padding      : '0.4rem 0.6rem',
			borderRadius : '0.3rem',
			color        : 'white',
			textAlign    : 'left',
			border       : 'none',
			'&:focus'    : {
				outline : 'none'
			},
			'&:disabled' : {
				color : '#F1F1F1'
			}
		},
		host : {
			width          : '100%',
			position       : 'absolute',
			display        : 'flex',
			justifyContent : 'center'
		},
		circle : {
			width           : '4rem',
			height          : '4rem',
			borderRadius    : '4rem',
			backgroundColor : '#999898',
			display         : 'flex',
			justifyContent  : 'center',
			alignItems      : 'center',
			margin          : '0.5rem 0'
		},
		hostName : {
			fontSize : '2rem',
			color    : 'white'
		},
		button : {
			width           : '4rem',
			height          : '4rem',
			borderRadius    : '4rem',
			boxShadow       : '2px 2px 4px #aaa',
			backgroundColor : '#8eba14',
			color           : 'white',
			'&:hover'       : {
				backgroundColor : '#f50057'
			}
		}
	});

const theme = createTheme({
	overrides : {
		MuiDialogTitle : {
			root : {
				backgroundColor : 'transparent',
				color           : '#999898',
				width           : '100%'
			}
		},
		MuiDialogContent : {
			root : {
				justifyContent : 'center',
				display        : 'flex',
				flexDirection  : 'column',
				alignItems     : 'center',
				overflowY      : 'none',
				padding        : '0.5rem 0'
			}
		},
		MuiDialogActions : {
			root : {
				justifyContent : 'space-around'
			}
		},
		MuiPaper : {
			rounded : {
				borderRadius : '0.5rem'
			}
		}
	}
});

const ChangePersonDialog = ({
	changePersonDialogOpen,
	setChangePersonDialogOpen,
	classes,
	room,
	roomClient,
	changeDisplayName,
	displayName
}) =>
{
	const [ name ] = useState(room.info ? room.info.user : '');
	const [ displayNameInput, setDisplayNameInput ] = useState(displayName);

	const handleClosePopup = async () =>
	{
		if (room.info !== null)
		{
			await roomClient.changeDisplayName(displayNameInput);
		}
		changeDisplayName(displayNameInput);
		setChangePersonDialogOpen(false);
	};

	const handleChangeDisplayName = (e) =>
	{
		setDisplayNameInput(e.target.value);
	};

	return (
		<MuiThemeProvider theme={theme}>
			<Dialog
				className={classes.root}
				open={changePersonDialogOpen}
				onClose={handleClosePopup}
				classes={{
					paper : classes.dialogPaper
				}}
			>
				<DialogTitle id='form-dialog-title'>
					<Box
						display='flex'
						alignItems='center'
						flexDirection='column'
					>
						<FlipCameraAndroidIcon className={classes.titleIcon} />
						<Typography className={classes.titleText}>
							<FormattedMessage
								id='settings.changePerson'
								defaultMessage='Change person in charge'
							/>
						</Typography>
					</Box>
				</DialogTitle>
				<DialogContent>
					<Box className={classes.infoGroup}>
						<Typography className={classes.contentText}>
							内部表示名
						</Typography>
						<input
							defaultValue={name}
							className={classes.input}
							type='text'
							disabled
						/>
					</Box>
					<Box className={classes.infoGroup}>
						<Typography className={classes.contentText}>
							外部表示名
						</Typography>
						<input
							className={classes.input}
							type='text'
							value={displayNameInput}
							onChange={(e) => handleChangeDisplayName(e)}
						/>
					</Box>
					{/* <Box className={classes.infoGroup} height='4.5rem'>
						<Typography className={classes.contentText}>
							アイコン変更
						</Typography>
						<Box className={classes.host}>
							<Box className={classes.circle}>
								<Typography className={classes.hostName}>U</Typography>
							</Box>
						</Box>
					</Box> */}
				</DialogContent>
				<DialogActions>
					<Button
						className={classes.button}
						onClick={handleClosePopup}
						color='primary'
					>
						OK
					</Button>
				</DialogActions>
			</Dialog>
		</MuiThemeProvider>
	);
};

ChangePersonDialog.propTypes =
{
	changePersonDialogOpen    : PropTypes.bool.isRequired,
	setChangePersonDialogOpen : PropTypes.func.isRequired,
	classes                   : PropTypes.object.isRequired,
	room                      : PropTypes.object.isRequired,
	roomClient                : PropTypes.object.isRequired,
	displayName               : PropTypes.string.isRequired,
	changeDisplayName         : PropTypes.func.isRequired
};

const makeMapStateToProps = () =>
{
	const mapStateToProps = (state) =>
	{
		return {
			changePersonDialogOpen : state.settings.changePersonDialogOpen,
			displayName            : state.settings.displayName,
			room                   : state.room
		};
	};

	return mapStateToProps;
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		setChangePersonDialogOpen : (changePersonDialogOpen) =>
		{
			dispatch(settingsActions.setChangePersonDialogOpen(changePersonDialogOpen));
		},
		changeDisplayName : (displayName) =>
		{
			dispatch(settingsActions.setDisplayName(displayName));
		}
	};
};

export default withRoomContext(connect(
	makeMapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room === next.room &&
				prev.settings === next.settings &&
				prev.settings.changePersonDialogOpen === next.settings.changePersonDialogOpen &&
				prev.settings.displayName === next.settings.displayName
			);
		}
	}
)(withStyles(styles)(ChangePersonDialog)));